import script from "./Suppliers.vue?vue&type=script&setup=true&lang=js"
export * from "./Suppliers.vue?vue&type=script&setup=true&lang=js"

import "./Suppliers.vue?vue&type=style&index=0&id=dd6d02d6&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd6d02d6"]])

export default __exports__